module.exports = __webpack_public_path__ + "img/y6.0e10b29a.jpg";